module.exports = __webpack_public_path__ + "media/images/close-79b071e3c7c4210cd59f24654d9c4320.svg";